import { useQuery } from '@tanstack/react-query';
import { pipe } from 'ramda';
import { publicApiPath } from 'src/common/publicApiPath';
import { verificationQueryKeys } from 'src/common/verificationQueryKeys';
import { BaseAxios, flatten } from 'src/config/axios';
import { ValueWrapper, extractValue } from 'src/utils/extractValue';

const getWssUrl = (verificationId: string) =>
  BaseAxios.get<ValueWrapper<string>>(
    `${publicApiPath}/${verificationId}/wss-url`
  ).then(pipe(flatten, extractValue));

export const useGetWssUrlQuery = ({
  verificationId,
  enabled,
}: {
  verificationId?: string;
  enabled: boolean;
}) =>
  useQuery(
    verificationQueryKeys.wssUrl(verificationId),
    () => (verificationId ? getWssUrl(verificationId) : undefined),
    {
      enabled: enabled && Boolean(verificationId),
    }
  );
